import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './Button.module.less';
import { logging } from '../../../actions/log';
import { setIframeVisible } from '../../../actions/layout';
import { gameCDKSetVisible } from '../../../actions/gamecdk';
import Toast from '../../Toast/Toast';
import { emptyLoginClose } from '../../../actions/user';
import { logNative } from '../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectLoginClose = createSelector(
  state => state.user,
  user => user.loginBoxClose,
);

export default memo(({ soft, info = {}, logInfo = {} }) => {
  let btnClassName = styles.btn_buy;
  if (info?.btnStyle === 'black') {
    btnClassName = styles.b_btn_buy;
  }
  if (info?.btnStyle === 'opacity') {
    btnClassName = styles.g_btn_buy;
  }

  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const userInfo = useSelector(selectUserInfo);
  const loginBoxClose = useSelector(selectLoginClose);
  const [isClickBtn, setIsClickBtn] = useState(false);

  useEffect(() => {
    return () => {
      setIsClickBtn(false);
      dispatch(emptyLoginClose());
    };
  }, []);

  useEffect(() => {
    if (isClickBtn && loginBoxClose?.result === 0) {
      setIsClickBtn(false);
      dispatch(emptyLoginClose());
    }
  }, [loginBoxClose, isClickBtn]);

  useEffect(() => {
    if (userInfo && userInfo?.st && isClickBtn) {
      logNative(`登录成功, 试图弹出购买cdk弹框`, {
        userInfo,
        isClickBtn,
      });
      try {
        if (soft?.sourceInfo?.sourceType === 2) {
          let gameCdkPrice = 0;
          let gameCdkSid = 0;
          let priceStr =
            soft?.sourceInfo?.sellInfo?.currentPrice || soft?.sourceInfo?.sellInfo?.originalPrice;
          gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', '')) || 0;
          gameCdkSid = soft?.sourceInfo?.sku?.sid || 0;
          setTimeout(() => {
            dispatch(
              gameCDKSetVisible({
                isShow: true,
                soft: { ...soft, gameCdkPrice, gameCdkSid },
                source: logInfo.source || logInfoData.source,
              }),
            );
          }, 10);
        }
      } catch (error) {}
      setIsClickBtn(false);
    }
  }, [soft, isClickBtn, userInfo]);

  const handleBuySoft = useCallback(
    (soft_info, logInfo_para) => {
      if (soft_info?.sourceInfo) {
        const logParam2 = {
          source: logInfo_para.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: soft_info.softID || soft_info.softId || soft_info.SoftID,
          softName: soft_info.softName,
          softType: '10',
          type:
            soft.sourceInfo && soft.sourceInfo.sellInfo && soft.sourceInfo.sellInfo.originalPrice
              ? 'b'
              : 'o', // 购买还是打开
          sourceUrl: soft_info.sourceInfo.sourceUrl,
          sourceInfo: soft_info.sourceInfo,
        };

        // 当为搜索结果也跳转过来的，带上附加信息
        // search_type 1: 热词  2: 联想词  3: 搜索词  4: 联想词 首位应用  5: 热词应用  6: 联想词 非首位应用
        if (logInfo_para.isSearch) {
          logParam2.search_type = logInfoData.search_type;
          logParam2.search_word = logInfoData.search_word;
          logParam2.lenovo_bizinfo = logInfo_para.lenovo_bizinfo || logInfoData.lenovo_bizinfo;
        }
        // 联想词softcard  做特殊处理 参数通过 logInfo (即logInfo_para) 传入
        if (
          logInfo_para.isSearch &&
          (logInfo_para.search_type === 4 ||
            logInfo_para.search_type === 5 ||
            logInfo_para.search_type === 6)
        ) {
          logParam2.source_p = logInfo_para.source_p;
          logParam2.source_pp = logInfo_para.source_pp;
          logParam2.search_type = logInfo_para.search_type;
          logParam2.search_word = logInfo_para.search_word;
          logParam2.lenovo_bizinfo = logInfo_para.lenovo_bizinfo || logInfoData.lenovo_bizinfo;
        }

        // 处理命令行直接跳入搜索结果页面没有search_word的问题
        if (logInfo_para.isSearch && logInfo_para.search_word) {
          logParam2.search_word = logInfo_para.search_word;
        }

        // 按钮点击打桩
        dispatch(
          logging({
            category: 'C',
            action: 'Install',
            label: '',
            param2: {
              ...logParam2,
              softType:
                soft_info.sourceInfo.sourceType === 1 || soft_info.sourceInfo.sourceType === 2
                  ? '11'
                  : '10',
            },
            param3: soft_info.bizInfo || null,
          }),
        );

        /**
         * softType:
         * 0: PC软件
         * 1: 安卓软件
         * 10: 网页版购买   即 soft?.androidType === '3' && sourceType=== 0
         * 11: 游戏CDK弹框购买     即 soft?.androidType === '3' && sourceType === 1
         * 12: 单机付费       即 soft?.androidType === '0' && soft?.payType === 1
         * 11: 凤凰游戏CDK弹框购买   即 soft?.androidType === '3' && sourceType === 2  // 9.0.11
         */
        if (soft_info.sourceInfo.sourceType === 1) {
          dispatch(
            setIframeVisible({
              visible: true,
              url: soft_info.sourceInfo.sourceUrl,
              soft,
              source: logInfo.source,
            }),
          );
        } else if (soft_info.sourceInfo.sourceType === 2) {
          if (userInfo && userInfo?.st) {
            let gameCdkPrice = 0;
            let gameCdkSid = 0;
            try {
              let priceStr =
                soft?.sourceInfo?.sellInfo?.currentPrice ||
                soft?.sourceInfo?.sellInfo?.originalPrice;
              gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', '')) || 0;
              gameCdkSid = soft?.sourceInfo?.sku?.sid || 0;
            } catch (error) {}

            dispatch(
              gameCDKSetVisible({
                isShow: true,
                soft: { ...soft, gameCdkPrice, gameCdkSid },
                source: logInfo.source || logInfoData.source,
              }),
            );
          } else {
            setIsClickBtn(true);
            if (window.CallNativeMethod) {
              window.CallNativeMethod('logout');
              window.CallNativeMethod('login');
            }
          }
        } else {
          if (soft_info.sourceInfo.sourceUrl) {
            window.open(soft_info.sourceInfo.sourceUrl);
          } else {
            Toast.error({ content: '数据错误！' });
          }
        }
      }
    },
    [dispatch, logInfoData, userInfo],
  );

  // 处理第三方的软件
  if (soft.androidType === '3') {
    let button_text = '打开';
    // 有价格则显示 购买
    if (
      soft.sourceInfo &&
      soft.sourceInfo.sellInfo &&
      (soft.sourceInfo.sellInfo.originalPrice || soft.sourceInfo.sellInfo.currentPrice)
    ) {
      button_text = '购买';
    }

    return (
      <div
        className={`${btnClassName} ${info.className || ''}`}
        onClick={e => {
          e.preventDefault();
          handleBuySoft(soft, logInfo);
        }}
      >
        {button_text}
        {/* !info?.btnStyle 由8.6新增样式，不需要展示价格来源信息，所以这里暂时用此字段来判断 */}
        {false &&
          !info?.btnStyle &&
          soft.sourceInfo &&
          soft.sourceInfo.sourceDesc &&
          !info.sourceHide && (
            <div
              className={styles.btn_buy_source}
              title={soft.sourceInfo.sourceDesc.length > 0 && soft.sourceInfo.sourceDesc}
            >
              {soft.sourceInfo.sourceDesc}
            </div>
          )}

        {/* !info?.btnStyle 由8.6新增样式，不需要展示价格来源信息，所以这里暂时用此字段来判断 */}
        {false &&
          !info?.btnStyle &&
          soft.sourceInfo &&
          soft.sourceInfo.sellInfo &&
          (soft.sourceInfo.sellInfo.currentPrice || soft.sourceInfo.sellInfo.originalPrice) && (
            <div className={styles.btn_buy_price}>
              <div className={styles.btn_buy_price_bg}>
                <div className={styles.btn_buy_price_bg_point} />
                {/* 有折扣价则两个价格都显示 */}
                {soft.sourceInfo.sellInfo.currentPrice &&
                  soft.sourceInfo.sellInfo.originalPrice && (
                    <>
                      <div className={styles.btn_buy_price_c}>
                        {soft.sourceInfo.sellInfo.currentPrice}
                      </div>
                      &nbsp;&nbsp;
                      <div className={styles.btn_buy_price_o}>
                        {soft.sourceInfo.sellInfo.originalPrice}{' '}
                      </div>
                    </>
                  )}
                {!soft.sourceInfo.sellInfo.currentPrice &&
                  soft.sourceInfo.sellInfo.originalPrice && (
                    <div className={styles.btn_buy_price_c}>
                      {soft.sourceInfo.sellInfo.originalPrice}
                    </div>
                  )}
                {soft.sourceInfo.sellInfo.currentPrice &&
                  !soft.sourceInfo.sellInfo.originalPrice && (
                    <div className={styles.btn_buy_price_c}>
                      {soft.sourceInfo.sellInfo.currentPrice}
                    </div>
                  )}
              </div>
            </div>
          )}
      </div>
    );
  }
});
